<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div :model="dataForm" class="whiteForm">
      <van-field
        v-model="dataForm.name"
        required
        clearable
        label="姓名"
        placeholder="收货人姓名"
      />
      <van-field
        v-model="dataForm.phone"
        required
        clearable
        label="电话"
        placeholder="收货人手机号"
      />
      <van-field
        v-model="zip"
        required
        clearable
        label="地区"
        placeholder="选择省/市/区"
        readonly
        @click="selectArea"
      />
      <van-field
        v-model="dataForm.address"
        required
        clearable
        label="详细地址"
        placeholder="街道门牌、楼层房间号等信息"
      />
      <van-cell title="设为默认">

        <van-switch
          v-model="dataForm.isDefault"
          size="24px"
        />

      </van-cell>
      <van-field
        v-model="fullAddress"
        rows="4"
        type="textarea"
        clearable
        label="自动识别"
        placeholder="粘贴全部地址信息，即可自动识别收件人、电话、地址。"
        @blur="onFullAddress"
      />
      <div class="downButton">
        <van-button v-if="dataForm.addressId" square :color="GetColorMain()" style="width:50%;border-bottom-left-radius: 0.5em;" type="default" size="large" plain :loading="deleteAddressLoading" loading-text="删除中..." @click="deleteAddress">删除</van-button>
        <van-button v-if="dataForm.addressId" square type="danger" size="large" :color="GetColorMain()" style="width:50%" :loading="editAddressLoading" loading-text="保存中..." @click="editAddress">保存</van-button>
        <van-button v-if="!dataForm.addressId" square type="danger" size="large" :color="GetColorMain()" style="width:100%" :loading="editAddressLoading" loading-text="保存中..." @click="editAddress">保存</van-button>
      </div>
    </div>
    <van-popup v-model="showAreaSelect" position="bottom">
      <van-area ref="pickerArea" :value="dataForm.zip==undefined?'110000':dataForm.zip.toString()" :loading="arealoading" :area-list="areaData" @confirm="confirmArea" @cancel="onCancelPicker" />
    </van-popup>
  </div>
</template>
<script>
import request from '@/utils/request'
import { getUrlKey, MyNotify } from '@/utils/base'
import { Button, Popup, Picker, Switch, Area, Dialog, Field, Cell } from 'vant'
import TopBar from '@/components/TopBar'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Switch.name]: Switch,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Area.name]: Area,
    [Dialog.name]: Dialog,
    [Field.name]: Field,
    [Cell.name]: Cell,
    TopBar
  },
  data() {
    return {
      title: '地址编辑',
      backurl: '/store/addressList',
      showAreaSelect: false,
      editAddressLoading: false,
      deleteAddressLoading: false,
      areaData: undefined,
      arealoading: false,
      dataForm: {
        addressId: undefined,
        zip: undefined,
        address: '',
        name: '',
        phone: '',
        phoneCountry: '86',
        isDefault: false
      },
      country: undefined,
      zip: undefined,
      fullAddress: '',
      fullAddressSave: ''
    }
  },
  created() {
    // 读取数据
    var addressId = getUrlKey('addressId')
    this.dataForm.addressId = addressId
    if (this.dataForm.addressId) {
      request({
        url: '/StoreHelper/getUserAddress',
        method: 'post',
        params: { addressId: addressId }
      }).then(Response => {
        if (!Response.success) {
          return
        }
        if (!Response.data) {
          MyNotify('error', '未找到地址 ', 2000)
          return
        }
        this.dataForm = Response.data
        this.zip = this.dataForm.zipString
      })
    }
  },
  methods: {
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    onFullAddress() {
      if (this.fullAddress === this.fullAddressSave) {
        return
      }
      // if (!this.fullAddress || this.fullAddress.length < 20) {
      //   MyNotify('info', '请输入完整的待识别地址 ', 2000)
      //   return
      // }
      request({
        url: '/StoreHelper/getAddressAnalysis',
        method: 'post',
        data: {
          address: this.fullAddress
        }
      }).then(Response => {
        this.editAddressLoading = false
        if (!Response.success) {
          return
        }
        this.fullAddressSave = this.fullAddress
        MyNotify('success', '识别地址成功,请核对是否正确!', 5000)
        this.dataForm = Response.data
        this.zip = this.dataForm.zipString
      })
    },
    doEditAddress() {
      this.editAddressLoading = true
      request({
        url: '/StoreHelper/updateAddress',
        method: 'post',
        data: this.dataForm
      }).then(Response => {
        this.editAddressLoading = false
        if (Response.success) {
          MyNotify('success', '保存地址成功', 2000)
          window.history.length > 1
            ? this.$router.go(-1)
            : this.$router.push(this.backUrl)
        }
      })
    },
    editAddress() {
      if (this.dataForm.name.length < 1) {
        MyNotify('error', '请输入收货人姓名')
        return
      }
      if (this.dataForm.phone.length < 1) {
        MyNotify('error', '请输入手机号码')
        return
      }
      if (!this.dataForm.zip) {
        MyNotify('error', '请选择地区')
        return
      }
      if (this.dataForm.address.length < 1) {
        MyNotify('error', '请输入详细地址')
        return
      }
      if (this.dataForm.phone.length !== 11) {
        Dialog.confirm({
          title: '非手机号码',
          message: '您输入的电话非11位手机号码，可能影响您签收快递，是否继续',
          cancelButtonText: '返回修改',
          confirmButtonText: '保存'
        }).then(() => {
          this.doEditAddress()
        })
      } else {
        this.doEditAddress()
      }
    },
    deleteAddress() {
      Dialog.confirm({
        title: '删除地址',
        message: '是否要删除这条地址数据',
        cancelButtonText: '取消',
        confirmButtonText: '删除'
      }).then(() => {
        this.deleteAddressLoading = true
        request({
          url: '/StoreHelper/deleteAddress',
          method: 'post',
          params: { addressId: this.dataForm.addressId }
        }).then(Response => {
          this.deleteAddressLoading = false
          if (Response.success) {
            MyNotify('success', '删除地址成功', 2000)
            window.history.length > 1
              ? this.$router.go(-1)
              : this.$router.push(this.backUrl)
          }
        })
      })
    },
    onCancelPicker() {
      this.showAreaSelect = false
      this.showCountrySelect = false
    },
    onCountry() {
      var select = this.$refs.pickerCountry.getValues()
      if (select.length > 0) {
        this.country = select[0].text
        this.dataForm.country = select[0].value
      }
      this.showCountrySelect = false
    },
    selectCountry() {
      this.showCountrySelect = true
      setTimeout(() => {
        if (this.dataForm.country != null) {
          var index2 = this.listCountry.findIndex(item => item.value === this.dataForm.country.toUpperCase())
          this.$refs.pickerCountry.setIndexes([index2])
        }
      }, 1)
    },
    confirmArea(selectList) {
      var title = ''
      var zipId = 0
      selectList.forEach(item => {
        title += item.name + ' '
        zipId = item.code
      })
      this.zip = title
      this.dataForm.zip = zipId
      this.showAreaSelect = false
    },
    selectArea() {
      this.showAreaSelect = true
      this.readAreaData()
    },
    readAreaData() {
      if (this.areaData !== undefined) {
        return
      }
      this.arealoading = true
      request({
        url: '/data/getArea',
        method: 'post'
      }).then(Response => {
        this.areaData = Response
        this.arealoading = false
      })
    }
  }
}
</script>
<style scoped>
.downButton{

}
.whiteForm{
  margin: 1em;
  border-radius: 0.5em;
  overflow: hidden;
}
</style>

